import axiosInstance from '../config/interceptors'
import {Constants} from "../config/constants";
import {Auth} from "./authService";
import {Alert} from "./alertService";

const getHeaders = (type) => (type === 'basic')
    ? {'Content-Type': 'application/json', 'Authorization': `Basic ${btoa(Constants.CLIENT_ID + ':' + Constants.CLIENT_SECRET)}`}
    : {'Content-Type': 'application/json', 'Authorization': `Bearer ${Auth.getAccessToken()}`};

const validateStacks = (stack, validate) => {
    console.log(stack)

    if (stack && Object.keys(stack).length) {
        const validates = [];
        Object.keys(stack).forEach((key) => validates.push({name: key, errors: [stack[key]]}))
        console.log(validates)
        validate(validates)
    }
}
export class RequestService {
    static getRequest({url, queries, auth, disableAlert, validate}, callback) {
        axiosInstance.get(url, {headers: getHeaders(auth), params: queries}).then((res) => {
            if (res?.status && res?.status === 200 && res?.data?.data)
                callback(res?.data?.data);
            if (res.status === 202) {
                if (!disableAlert)
                    Alert.success({title: res?.data?.message && typeof res?.data?.message === 'string' ? res?.data?.message : 'success', status: 202});
                callback(res?.data?.data ? res?.data?.data : null);
            } else if (res?.status === 422) {
                if (validate && res?.data?.stack) {
                    validateStacks(res.data.stack, validate)
                }
            }
            else if (res?.status && res?.status === 205 && res?.status && res?.data?.message)
                if (!disableAlert)
                    Alert.info({title: res?.data?.message && typeof res?.data?.message === 'string' ? res?.data?.message : 'no data found'});
        });
    }

    static postRequest({url, body, auth, disableAlert, validate}, callback) {
        const headers = getHeaders(auth);

        // --- CRITICAL ADDITION START ---
        if (body instanceof FormData) {
            // We delete this so the browser/Axios can set the
            // correct multipart/form-data header with the boundary
            delete headers['Content-Type'];
        }
        axiosInstance.post(url, body, {headers: getHeaders(auth)}).then((res) => {
            if (res.status === 201) {
                if (!disableAlert)
                    Alert.success({title: res?.data?.message && typeof res?.data?.message === 'string' ? res?.data?.message : 'success', status: 201});
                callback(res?.data?.data ? res?.data?.data : null);
            } else if (res.status === 422) {
                if (validate && res?.data?.data?.stack) {
                    validateStacks(res.data.data.stack, validate)
                }
            }
        });
    }

    // RequestService.js

    static silentPostRequest({ url, body, auth, validate }, callback) {
        const headers = getHeaders(auth);

        if (body instanceof FormData) {
            delete headers['Content-Type'];
        }

        axiosInstance.post(url, body, { headers })
            .then((res) => {
                if (res.status === 201 || res.status === 200) {
                    // Completely skips Alert.success
                    if (callback) callback(res?.data?.data ? res?.data?.data : res?.data);
                } else if (res.status === 422) {
                    if (validate && res?.data?.data?.stack) {
                        validateStacks(res.data.data.stack, validate);
                    }
                }
            })
            .catch((err) => {
                console.error("Silent API Error:", err);
            });
    }

    static deleteRequest({url, queries, auth, disableAlert}, callback) {
        axiosInstance.delete(url, {headers: getHeaders(auth), params: queries}).then((res) => {
            if (res.status === 202) {
                if (!disableAlert)
                    Alert.success({title: res.data && res.data.message && typeof res.data.message === 'string' ? res.data.message : 'success', status: 202});
                callback(res?.data?.data ? res?.data?.data : null);
            }
        });
    }

    // static putRequest({url, body, auth, disableAlert, validate}, callback) {
    //     axiosInstance.put(url, body, {headers: getHeaders(auth)}).then((res) => {
    //         if (res.status === 202) {
    //             if (!disableAlert)
    //                 Alert.success({title: res?.data?.message && typeof res?.data?.message === 'string' ? res?.data?.message : 'success', status: 202});
    //             callback(res?.data?.data ? res?.data?.data : null);
    //         } else if (res.status === 422) {
    //             if (validate && res?.data?.stack) {
    //                 validateStacks(res.data.stack, validate)
    //             }
    //         }
    //     });
    // }


    static putRequestForNotes({ url, body, auth }) {
        return axiosInstance.put(url, body, { headers: getHeaders(auth) })
            .then((res) => {
                if (res.status === 202 || res.status === 201 || res.status === 200) {
                    return res?.data;
                }
                throw new Error(res?.data?.message || "Validation failed");
            })
            .catch((err) => {
                // Re-throw the exact backend error payload so our catch block can read it
                throw err;
            });
    }

    static putRequest({url, body, auth, disableAlert, validate}, callback) {
        // Adding 'return' here allows you to use 'await' in your handleSubmit
        return axiosInstance.put(url, body, { headers: getHeaders(auth) })
            .then((res) => {
                // Check for 200, 201, or 202
                if (res.status === 202 || res.status === 201 || res.status === 200) {
                    if (!disableAlert) {
                        Alert.success({
                            title: res?.data?.message || 'Success',
                            status: res.status
                        });
                    }
                    if (callback) callback(res?.data?.data || null);
                }
                // Handle Validation Errors
                else if (res.status === 422) {
                    if (validate && res?.data?.stack) {
                        validateStacks(res.data.stack, validate);
                    }
                }
            })
            .catch((err) => {
                // ALWAYS catch errors, especially when tired!
                console.error("API Error:", err);
                Alert.error({ title: "Error", message: err.response?.data?.message || "Request failed" });
            });
    }

    static customPostRequest({url, body, auth, disableAlert, validate}, callback) {
        axiosInstance.post(url, body, {headers: getHeaders(auth)}).then((res) => {
            if (res.status === 201) {
                if (!disableAlert)
                    // Alert.success({title: res?.data?.message && typeof res?.data?.message === 'string' ? res?.data?.message : 'success', status: 201});
                callback(res?.data?.data ? res?.data?.data : null);
            } else if (res.status === 422) {
                if (validate && res?.data?.data?.stack) {
                    validateStacks(res.data.data.stack, validate)
                }
            }
        });
    }

    static customPutRequest({url, body, auth, disableAlert, validate}, callback) {
        axiosInstance.put(url, body, {headers: getHeaders(auth)}).then((res) => {
            if (res.status === 202) {
                if (!disableAlert)
                    // Alert.success({title: res?.data?.message && typeof res?.data?.message === 'string' ? res?.data?.message : 'success', status: 202});
                    callback(res?.data?.data ? res?.data?.data : null);
            } else if (res.status === 422) {
                if (validate && res?.data?.stack) {
                    validateStacks(res.data.stack, validate)
                }
            }
        });
    }

    static uploadRequest({file, alias, directory, disableAlert}, callback) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("alias", alias);
        formData.append("directory", directory);

        axiosInstance.post(`${Constants.UTILITIES}upload-file`, formData, {
            headers: getHeaders('bearer'),
            'Content-Type': 'multipart/form-data'
        }).then((res) => {
            if (res.status === 201) {
                if (!disableAlert)
                    Alert.success({title: res?.data?.message && typeof res?.data?.message === 'string' ? res?.data?.message : 'success', status: 201});
                callback(res?.data?.data ? res?.data?.data : null);
            }
        });
    }
}